var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUndo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 4.25C4.15625 4.25 4 4.4375 4 4.625V10.625C4 10.8438 4.15625 11 4.375 11H10.375C10.5625 11 10.75 10.8438 10.75 10.625V9.78125C10.75 9.5625 10.5625 9.40625 10.3438 9.40625L6.40625 9.5C7.375 7.375 9.5 5.875 12 5.875C15.375 5.875 18.125 8.625 18.125 12C18.125 15.4062 15.375 18.125 12 18.125C10.4062 18.125 9 17.5625 7.90625 16.5938C7.75 16.4688 7.53125 16.4688 7.40625 16.5938L6.78125 17.2188C6.625 17.375 6.625 17.625 6.78125 17.7812C8.15625 19 10 19.75 12 19.75C16.25 19.75 19.7188 16.3125 19.75 12.0312C19.75 7.78125 16.2812 4.28125 12 4.28125C9.3125 4.25 6.90625 5.625 5.53125 7.71875L5.59375 4.65625C5.59375 4.4375 5.4375 4.25 5.21875 4.25H4.375Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/undo.421ee9d71275f3518ecd12d952b49647.svg";
export { ForwardRef as ReactComponent };